module.exports = __webpack_public_path__ + "img/22-min.e4aec8e2.jpg";